// useIsMobileShell — true when the app should render the mobile shell
// (bottom tab bar): always in the native iOS app, or in any browser
// viewport under 768px (matches the NavSidebar drawer breakpoint).
import { useEffect, useState } from 'react';
import { isNative } from '../platform';

const QUERY = '(max-width: 767px)';

export function useIsMobileShell() {
  const [isNarrow, setIsNarrow] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(QUERY).matches : false
  );

  useEffect(() => {
    if (isNative) return undefined; // native is always the mobile shell
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setIsNarrow(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isNative || isNarrow;
}

export default useIsMobileShell;
